import React, { useId } from "react";
import { useTranslation } from "react-i18next";
import { CONTACT_PREFERENCES } from "../../utils/propertyRequestForm";
import { FieldError, fieldClass } from "./PropertyRequestFields";

// Private contact: kept in memory only (never in sessionStorage), never shown publicly.
export default function ContactFields({ contact, onChange, errors = {}, prefilledEmail = false }) {
  const { t } = useTranslation();
  const ids = { email: useId(), phone: useId() };
  const set = (patch) => onChange({ ...contact, ...patch });
  const wantsEmail = contact.preference === "email" || contact.preference === "both";
  const wantsPhone = contact.preference === "phone" || contact.preference === "both";
  return (
    <section className="space-y-4 rounded-3xl border border-slate-200 bg-white p-4 shadow-sm sm:p-6">
      <fieldset>
        <legend className="text-lg font-bold text-slate-900">{t("propertyRequest.contact.title")}</legend>
        <div className="mt-3 grid grid-cols-1 gap-2 min-[360px]:grid-cols-3">
          {CONTACT_PREFERENCES.map((p) => (
            <label key={p} className={`flex min-h-[48px] cursor-pointer items-center gap-2 rounded-2xl border px-3 py-2 text-sm font-semibold focus-within:ring-2 focus-within:ring-green-500/30 ${contact.preference === p ? "border-green-700 bg-green-50 text-green-900" : "border-slate-300 bg-white text-slate-800"}`}>
              <input type="radio" name="pr-contact" value={p} checked={contact.preference === p} onChange={() => set({ preference: p })} className="h-4 w-4 accent-green-700" />
              {t(`propertyRequest.contact.${p}`)}
            </label>
          ))}
        </div>
        <FieldError id="pr-contact-error" error={errors.preference} />
      </fieldset>
      {wantsEmail && (
        <div>
          <label htmlFor={ids.email} className="block text-sm font-semibold text-slate-800">
            {t("propertyRequest.contact.email")}
            {prefilledEmail && <span className="font-normal text-slate-500"> ({t("propertyRequest.contact.prefilled")})</span>}
          </label>
          <input id={ids.email} type="email" autoComplete="email" maxLength={200} className={fieldClass} value={contact.email}
            onChange={(e) => set({ email: e.target.value })} aria-invalid={Boolean(errors.email)} aria-describedby={errors.email ? `${ids.email}-error` : undefined} />
          <FieldError id={`${ids.email}-error`} error={errors.email} />
        </div>
      )}
      {wantsPhone && (
        <div>
          <label htmlFor={ids.phone} className="block text-sm font-semibold text-slate-800">{t("propertyRequest.contact.phone")}</label>
          <input id={ids.phone} type="tel" autoComplete="tel" inputMode="tel" maxLength={25} className={fieldClass} value={contact.phone}
            onChange={(e) => set({ phone: e.target.value })} aria-invalid={Boolean(errors.phone)} aria-describedby={errors.phone ? `${ids.phone}-error` : undefined} />
          <FieldError id={`${ids.phone}-error`} error={errors.phone} />
        </div>
      )}
      <p className="text-sm text-slate-600">{t("propertyRequest.contact.privacy")}</p>
    </section>
  );
}
